// extracted by mini-css-extract-plugin
module.exports = {"brandManagerApprovedDesignsTab":"tabsStyle_brandManagerApprovedDesignsTab__S7BPY"};